import $ from 'jquery';
import getCmp from "./helpers/cmpHelpers";
import {hasVendorConsent} from './helpers/cmpHelpers';

$(document).ready(function () {
    if (document.querySelector('.fts-instagram-inline-block-centered')) {
        const cmp = getCmp();
        if (cmp !== null) {
            getInstagramStatus();
            cmp('addEventListener', ['consent', getInstagramStatus, false], null);
            document.addEventListener('click', ev => {
                if(!ev.target.closest('.ume-starter-insta-consent-button')){
                    return;
                }
                cmp('setVendorConsent', ['s14', 1]);
            })
        }
        if (cmp === null) {
            consentmanagerInstaFeed();
        }
    }


});

async function getInstagramStatus() {
    await hasVendorConsent('s14').catch(e => console.log(e))
        .then((result) => {


                if (result) {
                    consentmanagerInstaFeed();


                } else {
                    const allMessages = document.querySelectorAll('.ume-starter-insta-consent');
                    if(allMessages.length > 0){
                        allMessages.forEach(message => {
                            message.classList.add('d-flex');
                            message.classList.remove('d-none');
                        })
                    }
                }
            }
        )

}

const consentmanagerInstaFeed = () => {
        const allImages = document.querySelectorAll('.fts-instagram-wrapper');
        const allMessages = document.querySelectorAll('.ume-starter-insta-consent');
        if(allMessages.length > 0){
            allMessages.forEach(message => {
                message.classList.remove('d-flex');
                message.classList.add('d-none');
            })
        }

        if (allImages.length > 0) {
            let calculated = false;
            let imgWidth = 0;
            let imgHeight = 0;
            let numberColumns = 0;
            let colMargin = 0;
            let colMarginDouble = 0;
            let parentWidth = 0;
            let forceColumns = '';
            allImages.forEach(img => {

                let content = img.getAttribute('data-style');
                if (content !== null && content !== '') {
                    img.setAttribute('style', content);
                    img.setAttribute('data-style', '');
                    // replace fts default image size calculation; see https://github.com/SlickRemix/feed-them-social/blob/master/includes/feeds/js/fts-global-full.js#L59
                    if (calculated === false) {
                        let parent = img.closest('.fts-instagram-inline-block-centered');
                        if (parent !== null) {
                            numberColumns = parent.getAttribute('data-ftsi-columns');
                            colMargin = parent.getAttribute('data-ftsi-margin');
                            forceColumns = parent.getAttribute('data-ftsi-force-columns');
                            colMarginDouble = parseFloat(colMargin) * 2;
                            parentWidth = parent.getBoundingClientRect().width;
                            if (numberColumns === '1' ||
                                numberColumns === '2' ||
                                numberColumns === '3' ||
                                numberColumns === '4' ||
                                numberColumns === '5' ||
                                numberColumns === '6' ||
                                numberColumns === '7' ||
                                numberColumns === '8') {
                                if (parentWidth <= '376' && forceColumns === 'no') {
                                    imgWidth = 'calc(100% - ' + colMarginDouble + 'px)';
                                    imgHeight = parentWidth - colMarginDouble + 'px';
                                } else if (parentWidth <= '736' && forceColumns === 'no') {
                                    imgWidth = 'calc(50% - ' + colMarginDouble + 'px)';
                                    imgHeight = (parentWidth / 2) - colMarginDouble + 'px';
                                } else {
                                    imgHeight = (parentWidth / numberColumns) - colMarginDouble + 'px';
                                    if (numberColumns === '8') {
                                        imgWidth = 'calc(12.5% - ' + colMarginDouble + 'px)';
                                    } else if (numberColumns === '7') {
                                        imgWidth = 'calc(14.28571428571429% - ' + colMarginDouble + 'px)';
                                    } else if (numberColumns === '6') {
                                        imgWidth = 'calc(16.66666666666667% - ' + colMarginDouble + 'px)';
                                    } else if (numberColumns === '5') {
                                        imgWidth = 'calc(20% - ' + colMarginDouble + 'px)';
                                    } else if (numberColumns === '4') {
                                        imgWidth = 'calc(25% - ' + colMarginDouble + 'px)';
                                    } else if (numberColumns === '3') {
                                        imgWidth = 'calc(33.33333333333333% - ' + colMarginDouble + 'px)';
                                    } else if (numberColumns === '2') {
                                        imgWidth = 'calc(50% - ' + colMarginDouble + 'px)';
                                    } else if (numberColumns === '1') {
                                        imgWidth = 'calc(100% - ' + colMarginDouble + 'px)';
                                    }

                                }
                            }
                            if (0 == parseFloat(imgHeight)) imgHeight = (parentWidth / numberColumns) - colMarginDouble + 'px';
                            calculated = true;
                        }


                    }
                    img.style.width = imgWidth;
                    img.style.height = imgHeight;
                    img.style.margin = colMargin;
                }
            })
        }

}